import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

type Props = {
	topMargin?: boolean
}

export const CenterContent = styled.div<Props>`
	margin: ${({ topMargin = true }) => (topMargin ? '10vh' : '0')} auto 0;
	height: 100%;
	padding: 0 16px 16px;
	max-width: 800px;

	${mobileMediaQuery(css`
		margin-top: 0;
		padding: 16px;
		max-width: 100%;
	`)}
`
